import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { useNotifications } from '../../../contexts/notificationContext';
import DataService from "../../../services/data.service";
import { IdProps } from '../../../types/IdProps';

const ProductCategory_tab_Items: React.FC<IdProps> = ({ id }) => {
    const [data, setData] = useState<[]>();
    const { handleException } = useNotifications();

    useEffect(() => {
        getTableData();
    }, [id]);

    function getTableData() {
        DataService.get<[]>('api/v1/ItemProductCategories/ByProductCategory/' + id)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    return (
        <DataTable
            name='dtProductCategoryItems'
            colInfos={[
                { key: true, dataProp: 'itemId', visible: false },
                { title: 'Item Nr', dataProp: 'item', dataType:'item' },
                { title: 'Name', dataProp: 'item.name', sort: 'asc' },
                { title: 'Item type', dataProp: 'item.itemType.name' },
                { title: 'Revision', dataProp: 'item.latestRevision' },
            ]}
            tableData={data}
        />
    );
}
export default ProductCategory_tab_Items;